<template>
  <div>
    <div class="col-xs-10 col-sm-10 col-md-9 col-xl-9  AboutUsleft">
      <div class="AboutUsImage">
        <img alt="" src="aiImg/aboutus/aboutUsMainSml.jpg" style="height:400px;"/>
      </div>
    </div>
    <div class="col-xs-6 col-sm-6 col-md-5 col-xl-5 AboutUsright">
      <div class="col-md-12 AboutUsHeader">
        <h1 class="AboutUstitle">About Us</h1>
      </div>
    </div>

    <div class="section AboutUsClear"><br><br>
      <div class="section section-tabs ">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-6 col-md-6 ml-auto col-xl-6 mr-auto columnCareer1">
              <div class="col-xs-12 col-sm-12 col-md-12 col-xl-12 " style="display: inline-block;padding:0;">
                <div class="card2 screenSmallOpacity2"
                     style="padding:4%; background-color: rgba(0, 185, 174, .7)">
                  <p class="item-title" style="font-weight: 600">What we do.</p>
                  <div class="item-text-container-aboutus-left">
                    AI Integration Inc. is a technologies company that specializes in integrating machine learning
                    into software solutions for commercial, government, and nonprofit organizations. Our team has
                    decades of experience within the information technology sector working with commercial companies
                    and government agencies. We continue research and development on the newest technologies including
                    new applications of artificial intelligence.
                    <br>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-xl-12 " style="display: inline-block; padding:0;">
                <div class="card7 service6 indexImageLeft">
                  <img alt="" src="aiImg/aboutus/teamcode300.jpg">
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-xl-12 indexCol" style="display: inline-block; padding:0;">
                <div class="card2 service6 indexImageRight screenSmallOpacity"
                     style="padding:4%; background-color: rgba(0, 185, 174, .2)">
                  <p class="item-title" style="font-weight: 600">Mission</p>
                  <div class="item-text-container-aboutus-left">
                    Help people and companies reach their full potential. That includes everyone from our employees to
                    our customers.
                    <br>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xs-12 col-sm-6 col-md-6 ml-auto col-xl-6 mr-auto columnCareer2">
              <div class="col-xs-12 col-sm-12 col-md-12 col-xl-12 " style="display: inline-block;padding:0;">
                <div class="card2" style="padding:4% 4% 1%;  background-color: rgba(0, 185, 174, .1)">
                  <div class="item-text-container-aboutus-right">
                    <p class="blockquote blockquote-primary">
                      Machine learning is not just about creating a model. One of the more difficult parts of using
                      machine learning is the operational deployment of a model. Project design, data planning and
                      preparation, model fitting, model deployment, monitoring, and optimization are all parts of the
                      operational deployment cycle that we use our experience to help you make sense of your data.
                      <br/>
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-xl-12 " style="display: inline-block;padding:0;">
                <div class="card2" style="padding:4%;  background-color: rgba(0, 185, 174, .3)">
                  <p class="item-title" style="font-weight: 600">Engineering Intelligence</p>
                  <div class="item-text-container-aboutus-right">
                    AI Integration’s goal is to be a trusted partner that assists you in reaching your goals and
                    provides solutions to help companies and individuals succeed. If we can’t help you, we can guide
                    you in the correct direction and find you the help you need through our IT partner relationships.
                    <br>
                    AI Integration prides itself on its strong customer service and the respect we earn from our
                    partners. With multiple awards received for outstanding customer service, our workforce is thorough,
                    friendly, and driven.
                    <br>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import {Button, FormGroupInput} from '@/components';

export default {
  name: 'landing',
  bodyClass: 'landing-page',
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  data() {
    return {
      form: {
        firstName: '',
        email: '',
        message: ''
      }
    };
  }
};

</script>

<style>
.AboutUsClear {
  clear: both;
}

.AboutUstitle {
  text-align: center;
  font-weight: 500;
  padding-top: 70px;
}

.AboutUsleft {
  margin-top: 90px;
  padding-right: 0 !important;
  padding-left: 0 !important;
  height: 400px;
}

.AboutUsright {
  float: right;
  margin-top: -150px;
  padding-right: 0 !important;
  padding-left: 0 !important;
  z-index: 1;
}

.AboutUsImage {
  background-color: #eeeeee;
  height: 400px;
}

.AboutUsHeader {
  background-color: #eeeeee;
  color: #2c2c2c;
  height: 200px;
}

@media (min-width: 1200px) {
  .card7 {
    height: 125px;
  }
}

@media (max-width: 1200px) {
  .card7 {
    height: 115px;
  }
}

@media (max-width: 991px) {
  .card7 {
    height: 170px;
  }
}

@media (max-width: 767px) {
  .card7 {
    height: 205px;
  }
}

@media (max-width: 575px) {
  .card7 {
    height: 200px;
  }

  .screenSmallOpacity {
    background-color: RGB(0, 185, 174) !important;
  }

  .screenSmallOpacity2 {
    background-color: rgba(0, 185, 174, .4) !important;
  }

  .AboutUsright {
    max-width: 300px;
  }

  .AboutUsImage {
    height: 100px;
  }

  .AboutUsHeader {
    height: 150px;
    margin-top: -20px;
  }

  .AboutUstitle {
    padding-top: 40px;
  }
}

</style>